@if (isOpen()) {
  <ai-iqboost-chat-dialog
    [scope]="scope"
    [scopeLabel]="scopeKey() | translate"
    [subtitle]="subtitleKey() | translate"
    [placeholder]="placeholderKey() | translate"
    [prompts]="prompts()"
    [promptsLoading]="loadingPrompts()"
    [(richUi)]="richUi"
    (closed)="isOpen.set(false)"
    (entityOpened)="actionCompleted.emit($event)"
  ></ai-iqboost-chat-dialog>
}
